<template>
  <ThemeProvider>
    <SidebarProvider>
      <RouterView />
    </SidebarProvider>
  </ThemeProvider>

  <!-- Global Notifications -->
  <div v-if="notifications.length > 0" class="fixed top-20 right-4 z-[100000] space-y-2">
    <NotificationStackCard
      v-for="(notification, index) in notifications"
      :key="notification.id"
      :message="notification.message"
      :type="notification.type"
      :duration="notification.duration"
      :show="true"
      :index="index"
      :total="notifications.length"
      @close="notificationService.remove(notification.id)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ThemeProvider from './components/layout/ThemeProvider.vue'
import SidebarProvider from './components/layout/SidebarProvider.vue'

import NotificationStackCard from '@/components/cards/NotificationStackCard.vue'
import { notificationService } from '@/services/notificationService'

// Get notifications from the service
const notifications = computed(() => notificationService.getNotifications().value)
</script>
